// extracted by mini-css-extract-plugin
export default {"headersContainer":"TransactionsFormHeaders_headersContainer__B0ogf"};